import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as searchJobsService from "../../services/searchJobs.service";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import Swal from "sweetalert2";
import { INQUIRY_STATUS, showFilterlist, SWAL_SETTINGS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import { usePermission } from '../../../../utils/commonfunction';

const JobsTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);

  // const [search] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Searched Jobs"), url: "" },
  ];
  const showInquiryFilterList = [
    { name: "list_heading_status", status: "" },
    { name: "new", status: "new" },
    { name: "responded", status: "responded" },
    { name: "in_progress", status: "in_progress" },
    { name: "closed", status: "closed" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {

      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        searchJobsService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data?.data?.list : []);
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }

    }, 300);
    return () => clearTimeout(getData)

  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);


  const viewfunction = (row) => {
    navigate(
      `/admin/jobs-management/view/${row._id}?page=1`
    );
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {

    const statusLabelMap = {
      "New": "new",
      "Responded": "responded",
      "In Progress": "in_progress",
      "Closed": "closed",
    };

    let sr;

    if (statusLabelMap[value]) {
      sr = { "status": statusLabelMap[value] };
    }

    else {
      sr = { ...search };
      if (String(value).length > 0) {
        sr[key] = value;
      } else {
        delete sr[key];
      }
    }
    // if(value.toLowerCase()==="status"){

    //   sr = { };
    // }

    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
  };



  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("Searched Jobs")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                    editable={false}
                  />
                </div>
                {/* <div className="me-3">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareSearch={prepareSearch}
                  />
                </div> */}

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("User Name")}</span>
                            {/* <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="category_id"
                            /> */}
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("Category")}</span>
                            {/* <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="category_id"
                            /> */}
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("Subcategory")}</span>
                            {/* <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="subcategory_id"
                            /> */}
                          </div>
                        </th>
                        {/*zi[ code add on*/}
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_zip_code")}</span>
                            {/* <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="subcategory_id"
                            /> */}
                          </div>
                        </th>
                        {/* <th>
                          <div className="sorting_column">
                            <span>{t("Gender")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="gender"
                            />
                          </div>
                        </th> */}

                        {/* <th>
                          <div className="sorting_column">
                            <span>{t("Experience")}</span>
                             <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="experience"
                            />
                          </div>
                        </th> */}
                        <th className="created_head">
                          <div className="sorting_column">
                            <span>{t("Created Date")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              defaultSorting={defaultSorting}
                              column="createdAt"
                            />
                          </div>
                        </th>
                        {can("/admin/jobs-management/view") && (
                          <th className="action_head">{t("list_heading_action")}</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >
                                <td>
                                  {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                </td>
                                <td>
                                  {row?.user?.name ? (
                                    <div className="d-flex">
                                      {row?.user?.name ? capitalizeFirstLetter(row.user?.name) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>
                                <td>
                                  {row?.categoryId?.title ? (
                                    <div className="d-flex">
                                      {row?.categoryId?.title ? capitalizeFirstLetter(row.categoryId?.title) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>
                                <td>
                                  {row?.subcategoryId?.title ? (
                                    <div className="d-flex">{capitalizeFirstLetter(row?.subcategoryId?.title)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>
                                <td>
                                  {row?.zip_code ? (
                                    <div className="d-flex">{capitalizeFirstLetter(row?.zip_code)}</div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>
                                {/* <td>
                                    {row?.gender ? (
                                      <div className="d-flex">{capitalizeFirstLetter(row.gender)}</div>
                                    ) : (
                                      <div className="d-flex">N/A</div>
                                    )}
                                  </td>
                                  <td>
                                    {row?.experience ? (
                                      <div className="d-flex">{(row?.experience + " " +  "year")}</div>
                                    ) : (
                                      <div className="d-flex">N/A</div>
                                    )}
                                  </td> */}
                                <td>
                                  {row.createdAt
                                    ? formateDateWithMonth(row.createdAt)
                                    : "N/A"}
                                </td>
                                {can("/admin/jobs-management/view") && (
                                  <td>
                                    <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                      <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                        {can("/admin/jobs-management/view") && (
                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                            <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                              <i className="ri-eye-fill"></i>
                                            </button>
                                          </Whisper>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Jobs",
                        path: "/admin/jobs-management/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default JobsTable;
